<!-- eslint-disable max-len -->
<template>
  <div class="ac-tech-batch-upload ac-card-content">
    <div class="ac-header-container">
      <button type="button" class="ac-close-button" @click="toggleActionModal(false)">
        <img src="@shared/assets/img/general/x-black.png" alt="x" class="ac-close" />
      </button>
      <div class="ac-header">Import CSV</div>
    </div>
    <div class="ac-body-container">
      <form
        v-if="!parsingTechs && !errorObj.uploadErrorArr"
        class="dropbox-form"
        enctype="multipart/form-data"
      >
        <div class="dropbox-container">
          <input
            ref="technicians"
            type="file"
            class="db-input"
            aria-label="upload"
            @change="selectedFile"
          />
          <img
            class="spreadsheet"
            src="@shared/assets/img/technician/spreadsheet.png"
            alt="Spreadsheet"
          />
        </div>
        <div class="dropbox-sub-container">
          <p class="upload-multiple-user">
            <span>
              Upload multiple users at once with a .CSV file. Drag &amp; drop your file here, or
            </span>
            <input
              id="fileInput"
              ref="technicians2"
              type="file"
              class="input-sub-container"
              @change="selectedFile"
            />
            <label for="fileInput" class="browse-item"> browse. </label>
          </p>
        </div>
      </form>
      <div v-else-if="parsingTechs" class="processing-container">
        <div class="p-container">
          <img src="@shared/assets/img/technician/spreadsheet.png" alt="Spreadsheet" />
          <div class="p-sub-item">
            <span>{{ fileName }}</span>
            <div class="p-sub-container">
              <span>Uploading</span>
              <img src="@shared/assets/img/general/loading.svg" alt="processing" />
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="errorObj.uploadErrorArr" class="error-container">
        <div v-for="error in errorObj.uploadErrorArr" :key="error" class="error-text">
          {{ error }}
        </div>
      </div>
    </div>
    <div class="ac-footer-container">
      <button type="button" class="f-button" @click="generateAndDownloadCSV">
        Download Example CSV
      </button>
      <button type="button" class="f-button" @click="handleCancel">Cancel</button>
      <button type="button" class="f-button blue" disabled>Invite All</button>
    </div>
  </div>
</template>

<script>
import technicianMixin from '@shared/mixins/technicianMixin';
import SACFilters from '@shared/components/sac/SACFilters.vue';

export default {
  name: 'NewTechnicianUpload',
  components: {
    SACFilters,
  },
  mixins: [technicianMixin],
  data() {
    return {
      fileName: '',
    };
  },
  methods: {
    generateAndDownloadCSV() {
      try {
        const csvData = [
          ['firstName', 'lastName', 'phone', 'email'],
          ['John', 'Smith', '888-888-8888', 'john.smith@example.com'],
        ];

        const csvContent = csvData.map((row) => row.join(',')).join('\n');
        const blob = new Blob([csvContent], { type: 'text/csv' });
        const blobURL = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = blobURL;
        link.download = 'technician_template.csv';

        link.click();

        URL.revokeObjectURL(blobURL);
      } catch (error) {
        console.error('Error generating or downloading CSV:', error);
      }
    },
    async selectedFile() {
      this.$store.dispatch('changeTechnicianValues', [
        {
          field: 'parsingTechs',
          value: true,
        },
      ]);
      const file =
        this.$refs.technicians.files.length > 0
          ? this.$refs.technicians.files[0]
          : this.$refs.technicians2.files[0];
      this.fileName = file.name;
      const reader = new FileReader();
      await new Promise((resolve) => {
        setTimeout(resolve, 2000);
      });
      reader.onload = (e) => this.parseTechUpload(e.target.result);
      reader.readAsText(file);
    },
    handleCancel() {
      this.$store.dispatch('changeTechnicianValues', [
        {
          field: 'errorObj',
          value: {},
        },
        {
          field: 'parsingTechs',
          value: false,
        },
      ]);
      this.toggleActionModal(false);
    },
  },
};
</script>

<style lang="scss" scoped>
.ac-tech-batch-upload {
  .ac-body-container {
    align-items: center;
    padding-bottom: 0 !important;
    position: relative;
  }

  .dropbox-form {
    flex: 1;
    width: 80%;

    .dropbox-sub-container {
      margin-top: 12px;
      display: flex;
      border-radius: 5px;
      text-align: left;
      font-weight: 500;

      .upload-multiple-user {
        letter-spacing: 0;
        line-height: 24px;
        min-height: 48px;
        position: relative;
        width: 373px;

        .browse-item {
          text-decoration: underline;
          cursor: pointer;
        }
      }

      .input-sub-container {
        display: none;
      }
    }

    .dropbox-container {
      border: 3px dashed $BLACK;
      width: 100%;
      height: 80%;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 5px;

      &:hover {
        opacity: 0.5;
      }

      .spreadsheet {
        height: 96px;
        width: 77px;
      }

      .db-input {
        opacity: 0;
        position: absolute;
        height: 80%;
        width: 75%;
        cursor: pointer;
      }

      .db-header {
        display: flex;
        flex-direction: column;
        font-size: 1.25rem;
        font-weight: 500;
        text-align: center;
      }
    }
  }

  .processing-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 50%;

    .p-container {
      display: flex;
      align-items: center;
      padding: 40px;

      .p-sub-item {
        padding: 10px;

        span {
          padding: 10px;
        }
      }

      .p-sub-container {
        display: flex;
        align-items: center;
        gap: 10px;
        height: 35px;

        span {
          letter-spacing: 0;
          line-height: 24px;
          white-space: nowrap;
          color: #979797;
          padding: 10px;
        }

        img {
          width: 25px;
        }
      }

      img {
        height: 96px;
        width: 77px;
      }
    }

    .p-spinner {
      width: 30px;
      margin-bottom: 12px;
      margin-top: 12px;
    }

    .p-header {
      font-size: 2rem;
      font-weight: 500;
    }
  }

  .ac-footer-container {
    display: flex;
    align-items: center;
    justify-content: center !important;

    .f-button {
      background-color: $N50;
      border-radius: 8px;
      color: white;
      padding: 12px 18px;
      font-weight: 500;

      &.blue {
        background-color: $NBLUE100;
        opacity: 0.3;
      }
    }
  }

  .branch-container {
    position: absolute;
    left: 70%;
  }

  .error-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding-top: 24px;

    .error-header {
      font-size: 1.25rem;
      font-weight: 500;
    }

    .error-text {
      font-size: 1.5rem;
      font-weight: 500;
      color: $TOMATO100;
    }

    .error-button {
      width: 200px;
      height: 48px;
      background-color: $N50;
      border-radius: 8px;
      color: $WHITE;
      font-weight: 500;
      cursor: pointer;

      &:hover {
        background-color: $N30;
      }
    }
  }
}
</style>
